/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconPicnicTable = createReactComponent("outline", "picnic-table", "IconPicnicTable", [["path", { "d": "M16 7l2 9m-10 -9l-2 9m-1 -9h14m2 5h-18", "key": "svg-0" }]]);

export { IconPicnicTable as default };
//# sourceMappingURL=IconPicnicTable.mjs.map
